/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { NativeIssueTableEntrypointProps } from './NativeIssueTable.entrypoint.types.tsx';

type NativeIssueTableEntryPointComponent = EntryPointComponent<
	{},
	{},
	NativeIssueTableEntrypointProps,
	{}
>;

export const nativeIssueTableEntryPoint: EntryPoint<NativeIssueTableEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<NativeIssueTableEntryPointComponent>(
			/* webpackChunkName: "async-issue-navigator-native-issue-table-entrypoint" */ './NativeIssueTableEntryPoint.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => ({}),
	});
